import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter, map, mergeMap, Subscription } from 'rxjs';

//Services
import { HelpersService } from './shared/services/helpers.service';
import { LinkService } from './shared/services/link.service';
import { SeoService } from './shared/services/seo.service';
import { SchemaService } from './shared/services/schema.service';

//Components
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);

  helpersService = inject(HelpersService);
  linkService = inject(LinkService);
  seoService = inject(SeoService);
  schemaService = inject(SchemaService);

  fragmentSub?: Subscription;

  footerCode: string = '';
  footerDate: string = '';
  footerYear: string = '';

  constructor(viewportScroller: ViewportScroller) {
    // Set a global offset
    // viewportScroller.setOffset([0, 139]); // Adjust as needed
  }

  ngOnInit() {
    // Source code for SEO implementation
    // DO NOT REMOVE
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        map((e) => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        this.schemaService.clearAllSchema();
        data['schema'] && this.schemaService.updateSchemaForUrl(data['schema']); //adds page schema
        this.linkService.updateCanonical(false);
        let seoData = data['seo'];
        if (seoData) {
          this.seoService.updateTitle(seoData['title']);
          this.seoService.updateMetaTags(seoData['metaTags']);
          this.helpersService.setLang(seoData['locale'] || 'en-US');
        }

        let hrefLang = data['hreflang'];
        if (hrefLang) {
          hrefLang.forEach((link: any) => {
            this.linkService.updateTag({
              rel: link.rel,
              href: link.href,
              hreflang: link.hreflang,
            })
          })
        }

        /** custom code: get footer code and date **/
        this.footerCode = data['code'] || '';
        this.footerDate = data['date'] || '';
        this.footerYear = data['year'] || '';
        /** custom code: load Ostro script */
        this.helpersService.setOstroLang(seoData['locale'] ? 'es' : 'en');
      });

    // Validate webp and set webp class
    this.helpersService.setWebpClass();

    //detect fragment
    this.fragmentSub = this.activatedRoute.fragment.subscribe((fragment) => {
      if (fragment) {
        //execute scrolling
        setTimeout(() => {
          //get jump to element height
          const jumpToEl = (this.helpersService.doc.querySelector('[jump-to]') as HTMLElement);
          const jumpToElHeight = jumpToEl ? (jumpToEl.offsetHeight) : 0;

          this.helpersService.scrollToItem(fragment, jumpToElHeight);
        }, 200);
      }
    });
  }

  ngOnDestroy(): void {
    this.fragmentSub?.unsubscribe();
  }

}
